import axios from "./axios";

export async function fetchMeetingMinutes(controller) {
  return axios({
    method: "get",
    url: "/meeting_minutes",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchMeetingMinutesById(id) {
  return axios
    .get(`/meeting_minutes/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createMeetingMinutes(payload, templateId = null) {
  const params = templateId ? { template_id: templateId } : {};
  return axios
    .post("/meeting_minutes", { meeting_minutes: payload }, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateMeetingMinutes(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .put(`/meeting_minutes/${id}`, { meeting_minutes: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteMeetingMinutes(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .delete(`/meeting_minutes/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function continueMeetingMinutes(id, meetingDate = null) {
  const params = meetingDate ? { meeting_date: meetingDate } : {};
  return axios
    .post(`/meeting_minutes/${id}/continue_meeting`, {}, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

// Templates
export async function fetchMeetingMinutesTemplates(controller) {
  return axios({
    method: "get",
    url: "/meeting_minutes_templates",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchMeetingMinutesTemplate(id) {
  return axios
    .get(`/meeting_minutes_templates/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createMeetingMinutesTemplate(payload) {
  const { groups, ...template } = payload || {};
  return axios
    .post("/meeting_minutes_templates", { template, groups })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateMeetingMinutesTemplate(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  const { groups, ...template } = typeof payload === "object" ? payload : {};
  return axios
    .put(`/meeting_minutes_templates/${id}`, { template, groups })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteMeetingMinutesTemplate(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .delete(`/meeting_minutes_templates/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

// Meetings
export async function fetchMeetingMinutesMeetings(meetingMinutesId) {
  return axios
    .get(`/meeting_minutes/${meetingMinutesId}/meetings`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchMeetingMinutesMeeting(meetingMinutesId, meetingId) {
  return axios
    .get(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createMeetingMinutesMeeting(meetingMinutesId, payload, params = {}) {
  return axios
    .post(`/meeting_minutes/${meetingMinutesId}/meetings`, { meeting: payload }, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateMeetingMinutesMeeting(meetingMinutesId, meetingId, payload) {
  return axios
    .put(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}`, { meeting: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteMeetingMinutesMeeting(meetingMinutesId, meetingId) {
  return axios
    .delete(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchMeetingMinutesMeetingPdf(meetingMinutesId, meetingId) {
  try {
    const response = await axios.get(
      `/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/pdf`,
      { responseType: "blob", headers: { Accept: "application/pdf" } }
    );
    const blob = await requirePdfBlob(response.data);
    const disposition = response.headers?.["content-disposition"] || "";
    const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
    const filename = match ? decodeURIComponent(match[1].replace(/"/g, "")) : "referat.pdf";
    return { blob, filename };
  } catch (error) {
    if (error?.code === "MEETING_PDF_INVALID") throw error;
    const data = error?.response?.data;
    if (typeof Blob !== "undefined" && data instanceof Blob) {
      await requirePdfBlob(data);
    }
    throw error.response?.data || error;
  }
}

function readBlobAsText(blob) {
  if (typeof blob?.text === "function") return blob.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
}

async function requirePdfBlob(data) {
  if (typeof Blob !== "undefined" && !(data instanceof Blob)) {
    const err = new Error("Invalid pdf");
    err.code = "MEETING_PDF_INVALID";
    throw err;
  }
  const header = await readBlobAsText(data.slice(0, 4));
  if (header !== "%PDF") {
    let message = "Invalid pdf";
    try {
      const json = JSON.parse(await readBlobAsText(data));
      if (Array.isArray(json.errors) && json.errors.length) {
        message = json.errors.join(", ");
      }
    } catch (_) {
      /* HTML or empty error body */
    }
    const err = new Error(message);
    err.code = "MEETING_PDF_INVALID";
    throw err;
  }
  return data;
}

export async function sendMeetingMinutesMeeting(meetingMinutesId, meetingId, payload) {
  return axios
    .post(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/send_email`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response?.data || error));
}

export async function saveMeetingMinutesMeetingAsTemplate(meetingMinutesId, meetingId, payload = {}) {
  return axios
    .post(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/save_as_template`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response?.data || error));
}

// Groups
export async function fetchMeetingMinutesGroups(meetingMinutesId, meetingId) {
  return axios
    .get(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createMeetingMinutesGroup(meetingMinutesId, meetingId, payload) {
  return axios
    .post(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups`, { group: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateMeetingMinutesGroup(meetingMinutesId, meetingId, groupId, payload) {
  return axios
    .put(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}`, { group: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteMeetingMinutesGroup(meetingMinutesId, meetingId, groupId, editVersion) {
  return axios
    .delete(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}`, {
      params: editVersion ? { edit_version: editVersion } : {},
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

// Entries
export async function fetchMeetingMinutesEntries(meetingMinutesId, meetingId, groupId) {
  return axios
    .get(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}/entries`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createMeetingMinutesEntry(meetingMinutesId, meetingId, groupId, payload) {
  return axios
    .post(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}/entries`, { entry: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateMeetingMinutesEntry(meetingMinutesId, meetingId, groupId, entryId, payload) {
  return axios
    .put(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}/entries/${entryId}`, { entry: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteMeetingMinutesEntry(meetingMinutesId, meetingId, groupId, entryId, editVersion) {
  return axios
    .delete(`/meeting_minutes/${meetingMinutesId}/meetings/${meetingId}/groups/${groupId}/entries/${entryId}`, {
      params: editVersion ? { edit_version: editVersion } : {},
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}
